import React, { useEffect, useMemo, useState } from 'react';
import './TheTeacherDashboard.css';
import { HiOutlineBookOpen } from 'react-icons/hi2';

export default function ExamCountSubjects({ paper_count_on_subject, dashboardDataLoading }) {

  const [activeTab, setActiveTab] = useState('English');

  const [edsider_teacher_subject_paper_count_english, setEnglish] = useState([]);
  const [edsider_teacher_subject_paper_count_sinhala, setSinhala] = useState([]);
  const [edsider_teacher_subject_paper_count_tamil, setTamil] = useState([]);

  const findChartTypedArray = (chart_type, allChartTypes = []) => {
    return allChartTypes.filter(item => item.language_name === chart_type);
  }


  useEffect(() => {

    setEnglish(findChartTypedArray("English", paper_count_on_subject));
    setSinhala(findChartTypedArray("සිංහල", paper_count_on_subject));
    setTamil(findChartTypedArray("தமிழ்", paper_count_on_subject));

  }, [paper_count_on_subject]);

  const getCurrentTabData = () => {
    switch (activeTab) {
      case 'English':
        return edsider_teacher_subject_paper_count_english;
      case 'සිංහල':
        return edsider_teacher_subject_paper_count_sinhala;
      case 'தமிழ்':
        return edsider_teacher_subject_paper_count_tamil;
      default:
        return [];
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const currentData = useMemo(() => getCurrentTabData() || [], [activeTab, paper_count_on_subject]);
  const maxCount = Math.max(50, ...currentData.map(item => Number(item?.paper_count) || 0));

  return (
    <div className="paper-count-body">
      <div className="paper-count-header">
        <div className="paper-count-title">
          <span className="paper-count-icon" aria-hidden="true">
            <HiOutlineBookOpen />
          </span>
          <h6 className="paper-count-heading">Paper Count by Subject</h6>
        </div>
        <span className="dots-icon">⋯</span>
      </div>

      <div className="paper-tabs">
        {['English', 'සිංහල', 'தமிழ்'].map((tab) => (
          <button
            key={tab}
            className={`paper-tab ${activeTab === tab ? 'active' : ''}`}
            onClick={() => handleTabChange(tab)}
            type="button"
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="paper-count-list">
        {!dashboardDataLoading && currentData.length > 0 ? (
          currentData.map((subject, index) => {
            const count = Number(subject?.paper_count) || 0;
            const percentage = Math.max(5, Math.round((count / maxCount) * 100));

            return (
              <div className="paper-count-row" key={index}>
                <div className="paper-count-row-header">
                  <span className="paper-count-label">{subject?.subject_name || "N/A"}</span>
                  <span className="paper-count-value">{count} Papers</span>
                </div>
                <div className="paper-count-bar">
                  <div className="paper-count-bar-fill" style={{ width: `${percentage}%` }} />
                </div>
              </div>
            );
          })
        ) : (
          dashboardDataLoading ?
            <div
              className="stu-card-title pt-2 col-md-12"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <i className="fas fa-spinner fa-spin"></i>
            </div>
            :
            <>
              No Data
            </>
        )}
      </div>
    </div>
  );
}
